/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keyword_Optimizer_Category_Industry_TermsInputs */

const en_keyword_optimizer_category_industry_terms = /** @type {(inputs: Keyword_Optimizer_Category_Industry_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Industry Terms`)
};

const de_keyword_optimizer_category_industry_terms = /** @type {(inputs: Keyword_Optimizer_Category_Industry_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Industry Terms`)
};

const fr_keyword_optimizer_category_industry_terms = /** @type {(inputs: Keyword_Optimizer_Category_Industry_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Industry Terms`)
};

const es_keyword_optimizer_category_industry_terms = /** @type {(inputs: Keyword_Optimizer_Category_Industry_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Industry Terms`)
};

const it_keyword_optimizer_category_industry_terms = /** @type {(inputs: Keyword_Optimizer_Category_Industry_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Industry Terms`)
};

const nl_keyword_optimizer_category_industry_terms = /** @type {(inputs: Keyword_Optimizer_Category_Industry_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Industry Terms`)
};

const pl_keyword_optimizer_category_industry_terms = /** @type {(inputs: Keyword_Optimizer_Category_Industry_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Industry Terms`)
};

const fi_keyword_optimizer_category_industry_terms = /** @type {(inputs: Keyword_Optimizer_Category_Industry_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Industry Terms`)
};

const da_keyword_optimizer_category_industry_terms = /** @type {(inputs: Keyword_Optimizer_Category_Industry_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Industry Terms`)
};

const sv_keyword_optimizer_category_industry_terms = /** @type {(inputs: Keyword_Optimizer_Category_Industry_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Industry Terms`)
};

/**
* | output |
* | --- |
* | "Industry Terms" |
*
* @param {Keyword_Optimizer_Category_Industry_TermsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const keyword_optimizer_category_industry_terms = /** @type {((inputs?: Keyword_Optimizer_Category_Industry_TermsInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keyword_Optimizer_Category_Industry_TermsInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_keyword_optimizer_category_industry_terms(inputs)
	if (locale === "fr") return fr_keyword_optimizer_category_industry_terms(inputs)
	if (locale === "es") return es_keyword_optimizer_category_industry_terms(inputs)
	if (locale === "it") return it_keyword_optimizer_category_industry_terms(inputs)
	if (locale === "nl") return nl_keyword_optimizer_category_industry_terms(inputs)
	if (locale === "pl") return pl_keyword_optimizer_category_industry_terms(inputs)
	if (locale === "fi") return fi_keyword_optimizer_category_industry_terms(inputs)
	if (locale === "da") return da_keyword_optimizer_category_industry_terms(inputs)
	if (locale === "sv") return sv_keyword_optimizer_category_industry_terms(inputs)
	return en_keyword_optimizer_category_industry_terms(inputs)
});